import { FormField } from "@/components/common/form-field";
import { PhoneField } from "@/components/common/masked-form-field";
import { SelectField } from "@/features/portal/components/onboarding/onboarding-fields";
import { PREF_CONTACT_OPTIONS } from "@/features/portal/components/onboarding/onboarding-options";
import {
  type TabProps,
  useBlurSave,
} from "@/features/portal/components/onboarding/tabs/tab-shared";

/** Contact Information tab (business clients). */
export function ContactTab({ save }: TabProps) {
  const onBlur = useBlurSave(save);
  return (
    <div className="grid gap-6">
      <div className="grid gap-4 sm:grid-cols-2">
        <FormField
          name="business_contact_first_name"
          label="Contact First Name"
          onBlur={onBlur("business_contact_first_name")}
        />
        <FormField
          name="business_contact_last_name"
          label="Contact Last Name"
          onBlur={onBlur("business_contact_last_name")}
        />
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        <FormField
          name="business_contact_title"
          label="Title"
          onBlur={onBlur("business_contact_title")}
        />
        <FormField name="salutation" label="Salutation" onBlur={onBlur("salutation")} />
      </div>

      <FormField name="email" label="Email" type="email" onBlur={onBlur("email")} />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <PhoneField name="home_phone" label="Home Phone" onBlur={onBlur("home_phone")} />
        <PhoneField name="mobile_phone" label="Mobile Phone" onBlur={onBlur("mobile_phone")} />
      </div>

      <div className="sm:max-w-xs">
        <SelectField
          name="preferred_contact_method"
          label="Preferred Contact Method"
          options={PREF_CONTACT_OPTIONS}
          onCommit={save}
        />
      </div>
    </div>
  );
}
